import React, {lazy,Suspense,useState} from 'react';

import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Home from './pages/Home'
import './App.css';
import NavBar from './components/Nav/NavBar'
import SideBar from './components/Nav/Sidebar'
import IsUserLoggedIn from './helpers/isUserLoggedIn'
import PrivateRoute from './helpers/PrivateRotue'
import ProfilePage from './pages/ProfilePage'

const YourWardrobe = lazy(() => import ('./pages/Wardrobe'))
const GetStarted = lazy(() => import ('./pages/GetStarted'))
const LoginPage = lazy(() => import ('./pages/LoginPage'))
const RegisterPage = lazy(() => import ('./pages/RegisterPage'))
const SocialPage = lazy(() => import ('./pages/SocialMainPage'))
// const ProfilePage = lazy(() => import ('./pages/ProfilePage'))


// import GetStarted from './pages/GetStarted'
// import LoginPage from './pages/LoginPage'
// import YourWardrobe from './pages/Wardrobe'
// import RegisterPage from './pages/RegisterPage'
// import SocialPage from './pages/SocialMainPage'



function App() {
  const [isOpen, setIsOpen] = useState(false)
  

  const toggleDropDown = (buttonForLogin) => {
    //console.log("APP TOGGLE OCCURING", buttonForLogin)
    if(buttonForLogin){
      sessionStorage.removeItem('user');
    }
    setIsOpen(!isOpen)
  }

  return (
    <>
      <Router>
        <NavBar toggle={toggleDropDown}/>
        <SideBar isOpen={isOpen} toggle={toggleDropDown}/>
        <Suspense fallback={<p>Loading</p>}>
        <Switch>
          <Route path='/' exact component={Home}/>
          <Route path='/Tutorial' exact component={GetStarted}/>
          <Route path='/Yourwardrobe' exact component={(props) => <YourWardrobe {...props}/>}/>
          <PrivateRoute exact path="/Profile" component={ProfilePage} />
          <PrivateRoute exact path="/Social" component={SocialPage} />
          <IsUserLoggedIn exact path="/Login" component={LoginPage} />
          <IsUserLoggedIn exact path="/Register" component={RegisterPage} />
        </Switch>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
